<template>
  <div class="verification-code-wrapper">
    <code-input
      ref="code-input"
      class='input'
      type='number'
      id="codeInput"
      :fields='length'
      v-on:change="onChange"
      v-on:complete="onComplete"
    />
  </div>
</template>

<script>
import CodeInput from 'vue-verification-code-input';

export default {
  name: 'verification-code',
  components: {
    CodeInput,
  },
  props: {
    length: {
      type: Number,
      default: 6,
    },
    value: {
      type: String,
    },
    onEnter: {
      type: Function,
    },
  },
  methods: {
    onComplete(verificationCode) {
      this.$emit('onComplete', verificationCode);
    },
    onChange(verificationCode) {
      this.$emit('onChange', verificationCode);
    },
    clearInput() {
      this.$refs['code-input'].values = this.$refs['code-input'].values.map(() => '');

      const firstInput = document.querySelector('.verification-code-wrapper .react-code-input').children[0];
      firstInput.focus();
    },
  },
  mounted() {
    if (this.onEnter) {
      document.querySelector('input[data-id="5"]').addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          this.onEnter();
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  .verification-code-wrapper {
    display: flex;
    margin: auto;
    width: fit-content;
  }
</style>

<style lang="scss">
  .verification-code-wrapper {
    .react-code-input-container {
      height: auto !important;
    }

    .react-code-input {
      display: flex;
      flex-direction: row;
      justify-content: center;

      input {
        background-color: white !important;

        border: 1px solid #CBD5E1 !important;
        border-radius: 8px !important;

        width: 42px !important;
        height: 42px !important;

        font-family: 'Manrope' !important;
        font-size: 16px !important;
        line-height: 24px;
        text-align: center !important;

        margin: 0px 4px !important;

        caret-color: var(--black) !important;

        &:first-child {
          margin-left: 0px !important;
        }

        &:last-child {
          margin-right: 0px !important;
        }

        &:focus {
          border-color: #ED0059 !important;
        }
      }
    }
  }
</style>
